"use strict";

exports.__esModule = true;
exports.RumEventType = exports.AppType = void 0;
var RumEventType = exports.RumEventType = /*#__PURE__*/function (RumEventType) {
  RumEventType["VIEW"] = "view";
  RumEventType["RESOURCE"] = "resource";
  RumEventType["EXCEPTION"] = "exception";
  RumEventType["LONG_TASK"] = "longtask";
  RumEventType["ACTION"] = "action";
  RumEventType["CUSTOM"] = "custom";
  return RumEventType;
}({});
var AppType = exports.AppType = /*#__PURE__*/function (AppType) {
  AppType["browser"] = "browser";
  AppType["miniapp"] = "miniapp";
  return AppType;
}({});